var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnapchat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,2H13A11.1,11.1,0,0,0,2,13V35A11.1,11.1,0,0,0,13,46H35A11.1,11.1,0,0,0,46,35V13A11.1,11.1,0,0,0,35,2Zm2.2,29.2a3,3,0,0,1-.8.7l-2.6.6-.3.2a5.6,5.6,0,0,0-.1.7v.2a.6.6,0,0,1-.1.4c-.1.2-.2.3-.4.3H29.7a5,5,0,0,0-2.1,1A5.6,5.6,0,0,1,24,36.6h-.3a5.6,5.6,0,0,1-3.6-1.4,5.8,5.8,0,0,0-2.1-1H14.9a.5.5,0,0,1-.5-.3,1.4,1.4,0,0,1-.2-.6h0a1.6,1.6,0,0,0-.3-.6.2.2,0,0,0-.2-.2,9.4,9.4,0,0,1-2.6-.7,1.8,1.8,0,0,1-.8-.6h0l.3-.3a5.8,5.8,0,0,0,2.5-.9,6.4,6.4,0,0,0,1.7-1.6A6.2,6.2,0,0,0,16.2,26h0a1.4,1.4,0,0,0,.2-1.2c-.3-.7-1.1-.9-1.7-1.1h-.1l-.3-.2a1.9,1.9,0,0,1-.9-.5.7.7,0,0,1-.3-.6.7.7,0,0,1,.4-.5c.3-.2.8-.3,1-.1s1.5.5,2,.2.2-.2.2-.3-.1-.5-.1-.7h0c-.1-1.8-.2-4.1.3-5.4a8.1,8.1,0,0,1,1.7-2.3,5.2,5.2,0,0,1,1.9-1.2,6.9,6.9,0,0,1,3-.7H24a7.2,7.2,0,0,1,3,.7,6.2,6.2,0,0,1,1.9,1.2,6.3,6.3,0,0,1,1.6,2.3c.6,1.3.4,3.6.3,5.4h0v.4h0a.5.5,0,0,0,.2.4h.6l1.2-.4h.9a.8.8,0,0,1,.7.7c0,.1,0,.2-.2.5l-1,.5h-.4a2.5,2.5,0,0,0-1.7,1,1.6,1.6,0,0,0,.2,1.3h0c.3.7,2.1,4.1,5.7,4.7a.5.5,0,0,1,.2.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.a67687873b77408198e190dd5c863a0c.svg";
export { ForwardRef as ReactComponent };